module.exports = __webpack_public_path__ + "static/media/checkedBox.3af32cd9.svg";